import { render, staticRenderFns } from "./emails-communication-table.vue?vue&type=template&id=579951eb&scoped=true&"
import script from "./emails-communication-table.vue?vue&type=script&lang=js&"
export * from "./emails-communication-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579951eb",
  null
  
)

export default component.exports